import React, { useEffect, useState } from "react";
import ConfigData from "../../master/components/ConfigData";
import { Checkbox, Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, } from "@material-ui/core";
import { EmptyCollection, ExportMenu, FilterComponent, Pagination, ImportMenu, DeletePopUp, PageLoader, STableLoader } from "../../../shared_elements";
import { globalDeleteService, globalExportService, globalGetService, globalPostService, globalPutService } from "../../../../globalServices";
import { checkApiStatus,checkPermission } from "../../../utils_v2";
import ApuTypesList from "../components/ApuTypesList";
import AddEditApuTypes from "../components/AddEditApuTypes";
import { Link, withRouter } from 'react-router';
import { trackActivity } from "../../../../utils/mixpanel";
import { useSnackbar } from "notistack";
import AddIcon from '@material-ui/icons/Add';
import LinkingPopup from "../../../shared_elements/LinkingPopup";
import { apuTypeFilters } from "..";
import NoAccess from "../../aircraftModels/components/NoAccess";

const ApuTypesObj = {
    name: null,
    manufacturer: null,
    aircraft_type:[],
    remarks: null,
}

const ApuTypesHeader = ({ handleSelectAll, isSelectAllChecked, createSortHandler, sortInfo, deleted, isApuTypes }) => {
    return (
        <TableHead>
            <TableRow>
                {!deleted ? <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, }} >{checkPermission('config_data', 'apu_types', 'D') &&<Checkbox checked={isSelectAllChecked} onChange={handleSelectAll} color="primary" size="small" />}Action(s)</TableCell> : null }
                <TableCell >
                    { !isApuTypes ? <TableSortLabel
                        active={sortInfo.sort === 'name' ? true : false}
                        direction={sortInfo.sort === 'name' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('name')}
                    >
                        Name
                    </TableSortLabel> : "Name" }
                </TableCell>
                <TableCell >
                    {!isApuTypes ? <TableSortLabel
                        active={sortInfo.sort === 'manufacturer' ? true : false}
                        direction={sortInfo.sort === 'manufacturer' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('manufacturer')}
                    >
                        Manufacturer
                    </TableSortLabel> : "Manufacturer" }
                </TableCell>
                <TableCell > Linked A/C Types </TableCell>
                <TableCell >
                    <div style={{ width: '140px' }}>
                        {!isApuTypes ? <TableSortLabel
                            active={sortInfo.sort === 'created_by' ? true : false}
                            direction={sortInfo.sort === 'created_by' ? sortInfo.sort_by : 'asc'}
                            onClick={() => createSortHandler('created_by')}
                        >
                            Created By
                        </TableSortLabel> : "Created By"}
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ width: '150px' }}>
                        {!isApuTypes ? <TableSortLabel
                            active={sortInfo.sort === 'updated_by' ? true : false}
                            direction={sortInfo.sort === 'updated_by' ? sortInfo.sort_by : 'asc'}
                            onClick={() => createSortHandler('updated_by')}
                        >
                            Last Updated By
                        </TableSortLabel> : "Last Updated By"}
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ minWidth: '150px' }}>
                        {!isApuTypes ? <TableSortLabel
                            active={sortInfo.sort === 'remarks' ? true : false}
                            direction={sortInfo.sort === 'remarks' ? sortInfo.sort_by : 'asc'}
                            onClick={() => createSortHandler('remarks')}
                        >
                            Remarks
                        </TableSortLabel> : "Remarks"}
                    </div>
                </TableCell>
            </TableRow>
        </TableHead >
    )
}
const ApuTypes = ({params, isApuTypes ,deleted}) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState({});
    const [pageSelections, setPageSelections] = useState({});
    const [currentPage, setCurrentPage] = useState({});
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [bulkDelete, setBulkDelete] = useState({ modal: false, data: null })
    const [bulkRevert, setBulkRevert] = useState({ modal: false, data: null })
    const [bulkUnlink, setBulkUnLink] = useState({ modal: false, data: null })
    const [unLinkApuTypes, setUnLinkApuTypes] = useState({ modal: false, data: null });
    const [deleteApuTypes, setDeleteApuTypes] = useState({ modal: false, data: null });
    const [revertApuTypes, setRevertApuTypes] = useState({ modal: false, data: null });
    const [addEditApuTypes, setAddEditApuTypes] = useState({ modal: false, data: null, type: '' });
    const [apuTypesInfo, setApuTypesInfo] = useState({ list: [], pagination: {} });
    const [linkingApu, setLinkingApu] = useState({ modal: false, data: null })
    const [circularLoader, setCircularloader] = useState(false)
    const [manufacturersFilter, setManufacturersFilter] = useState([]);
    const [filterAircraftTypes, setFilterAircraftTypes] = useState([]);
    useEffect(() => {
        getApuTypes({per_page:50}, !isApuTypes ? "skeletonLoader" : "pageLoader");
        trackActivity('Console Management', { page_title: !isApuTypes ? 'Config Data : Apu Types' : 'Config Data : Aircraft Types View page', event_type: !isApuTypes ?'Page Visited' : 'Apu Types Tab Clicked' })
        getManufacturers();
        getAircraftTypes()
    }, [])


    const getApuTypes = (query={}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)

        const url = ! isApuTypes ? `config-data/apu-type/` : `config-data/aircraft-type/?linked_aircraft_types_name=APU_type&id=${params?.id}&action=link`;

        globalGetService(url, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setApuTypesInfo(response.data.data)
                    if(query){
                        delete query.page
                        delete query.per_page
                        delete query.sort
                        delete query.sort_by
                        setFilter(query)
                    }
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }

    const toggleBulkOps = (item, checked, currentPage) => {
        setPageSelections(prevSelections => {
            const updatedSelections = { ...prevSelections };
            if (checked) {
                updatedSelections[currentPage] = updatedSelections[currentPage] || [];
                updatedSelections[currentPage].push(item?.id);
            } else {
                updatedSelections[currentPage] = updatedSelections[currentPage]?.filter(id => id !== item?.id);
            }
            return updatedSelections;
        });
    };

    const onDelete = () => {
        setLoading(true)
        const ids = !deleteApuTypes.data ? Object.values(pageSelections).flat().filter(id => {
            const item = apuTypesInfo.list.find(item => item.id === id);
            return item && !item.deleted_at;
        }) : deleteApuTypes.data.id

        globalDeleteService(`config-data/apu-type/bulk-delete/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setLoading(false)
                    setDeleteApuTypes({ modal: false, data: null });
                    getApuTypes({...filter, page: apuTypesInfo?.pagination?.page, per_page: apuTypesInfo?.pagination?.per_page}, 'pageLoader');
                    setCurrentPage({});
                    setBulkDelete({ modal: false, data: null })
                    setPageSelections({});
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Apu Types',
                        event_type: `Item Deleted`,
                        event_desc: 'Apu Types Deleted Successfully',
                        success_msg: response?.data?.message,
                        deleted_id: ids
                    });
                } else {
                    setDeleteApuTypes({ modal: false, data: null });
                    setLoading(false)
                    setBulkDelete({ modal: false, data: null })
                    setPageSelections({});
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Apu Types',
                        event_type: `Item Deleted`,
                        event_desc: 'Apu Types Deletion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const onRevert = () => {
        setLoading(true)
        const ids = !revertApuTypes.data ? Object.values(pageSelections).flat().filter(id => {
            const item = apuTypesInfo.list.find(item => item.id === id);
            return item && item.deleted_at;
        }) : revertApuTypes.data;

        globalPutService(`config-data/apu-type/restore/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setRevertApuTypes({ modal: false, data: null });
                    getApuTypes({...filter, page: apuTypesInfo?.pagination?.page, per_page: apuTypesInfo?.pagination?.per_page}, 'pageLoader');
                    setCurrentPage({});
                    setLoading(false)
                    setPageSelections({});
                    setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } })
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Apu Types',
                        event_type: `Item Reverted`,
                        event_desc: 'Apu Types Reverted Successfully',
                        success_msg: response?.data?.message,
                        reverted_id: ids
                    });
                } else {
                    setRevertApuTypes({ modal: false, data: null });
                    setLoading(false)
                    setPageSelections({});
                    setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } })
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Apu Types',
                        event_type: `Item Reverted`,
                        event_desc: 'Apu Types Reversion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const linkUnlink = (type, ids) => {
        const idss = !unLinkApuTypes.data ? Object.values(pageSelections).flat().filter(id => id) : [unLinkApuTypes?.data?.id]
        let payload;
        if (type === 'link') {
            payload = {
                aircraft_type_id: params.id || null,
                linked_aircraft_types: "apu_type" || null,
                ids: ids || [],
            };
        } else {
            payload = {
                aircraft_type_id: params.id || null,
                linked_aircraft_types: "apu_type" || null,
                ids: idss || [],
                action: 'unlink'
            };
        }

        const apiUrl = `config-data/aircraft-type/`;
        setCircularloader(true);
        globalPostService(apiUrl, payload)
            .then((response) => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    toggleModalFn();
                    getApuTypes();
                    setPageSelections({})
                    trackActivity('Console Management', {
                        event_desc: type === 'link'? `Apu Types Linked Successfully` : 'Apu Types unLinked Successfully',
                        page_title: 'Config Data : Aircraft Types View Page',
                        event_type: type === 'link' ? 'Item Linked' : 'Item UnLinked',
                        updated_id: type === 'link'? ids : idss || null,
                        success_msg: response?.data?.message,
                        data:JSON.stringify(payload)
                    })
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    setPageSelections({})
                    getApuTypes();
                    toggleModalFn();
                    trackActivity('Console Management', {
                        event_desc: type === 'link'? 'Apu Types Linking Failed' : 'Apu Types Unlinking Failed',
                        page_title: 'Config Data : Aircraft Types View Page',
                        event_type: type === 'link' ? 'Item Linked' : 'Item UnLinked',
                        updated_id: type === 'link'? ids : idss || null,
                        error_msg: response?.data?.message,
                        data:JSON.stringify(payload)
                    })
                }
                setCircularloader(false);
            })
    }

    const handleSelectAll = (event, currentPage) => {
        if (event?.target.checked) {
            const allIds = apuTypesInfo?.list.map(item => item.id);
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: allIds }));
        } else {
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: [] }));
        }
    };

    const getFilteredSelectionCounts = () => {
        let deleteCount = 0;
        let revertCount = 0;

        if (pageSelections[currentPage]?.length) {
            pageSelections[currentPage].forEach(id => {
                const selectedItem = apuTypesInfo?.list?.find(item => item?.id === id);
                if (selectedItem) {
                    if (selectedItem?.deleted_at) {
                        revertCount++;
                    } else {
                        deleteCount++;
                    }
                }
            });
        }
        return { deleteCount, revertCount };
    };

    const { deleteCount, revertCount } = getFilteredSelectionCounts();

    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getApuTypes({ ...filter, ...sortQuery, page: 1, per_page: apuTypesInfo?.pagination?.per_page || 20 }, 'pageLoader');
    }

    const isSelectAllChecked = apuTypesInfo?.list?.length > 0 && pageSelections[currentPage]?.length === apuTypesInfo?.list?.length;

    const getConfirmColor = () => {
        if (revertApuTypes?.modal || bulkRevert?.modal) return "primary";
        if (deleteApuTypes?.modal || bulkDelete?.modal) return "secondary";
        if (unLinkApuTypes?.modal || bulkUnlink?.modal) return "secondary";
        return "";
    };

    const getConfirmText = () => {
        if (revertApuTypes?.modal || bulkRevert?.modal) return "Revert";
        if (deleteApuTypes?.modal || bulkDelete?.modal) return "DELETE";
        if (unLinkApuTypes?.modal || bulkUnlink?.modal) return "UnLink"
        return "";
    };

    const getModal = () => {
        if (revertApuTypes?.modal) return revertApuTypes.modal;
        if (deleteApuTypes?.modal) return deleteApuTypes.modal;
        if (bulkDelete?.modal) return bulkDelete.modal;
        if (bulkRevert?.modal) return bulkRevert.modal;
        if (unLinkApuTypes?.modal) return unLinkApuTypes.modal;
        if (bulkUnlink?.modal) return bulkUnlink.modal;
        return null;
    };

    const getTitle = () => {
        if (revertApuTypes?.modal) return "Revert Apu Types";
        if (deleteApuTypes?.modal) return "Delete Apu Types";
        if (bulkDelete?.modal) return `Delete Apu Types (${deleteCount})`;
        if (bulkRevert?.modal) return `Revert Apu Types (${revertCount})`;
        if (unLinkApuTypes?.modal) return "UnLink Apu Types"
        if (bulkUnlink?.modal) return `Unlink Apu Types (${deleteCount})`
        return "";
    };

    const getContent = () => {
        if (revertApuTypes?.modal || bulkRevert?.modal)
            return "Are you sure, you want to Revert?";
        if (deleteApuTypes?.modal || bulkDelete?.modal)
            return "Are you sure, you want to Delete?";
        if (unLinkApuTypes?.modal || bulkUnlink?.modal)
            return "Are you sure, you want to UnLink"
        return "";
    };

    const toggleModalFn = () => {
        if (revertApuTypes?.modal) {
            setRevertApuTypes({ modal: false, data: null });
        } else if (deleteApuTypes?.modal) {
            setDeleteApuTypes({ modal: false, data: null });
        } else if (bulkDelete?.modal) {
            setBulkDelete({ modal: false, data: null });
        } else if (bulkRevert?.modal) {
            setBulkRevert({ modal: false, data: null });
        } else if (bulkUnlink?.modal) {
            setBulkUnLink({ modal: false, data: null });
        } else if (unLinkApuTypes?.modal) {
            setUnLinkApuTypes({ modal: false, data: null});
        } else {
            setLinkingApu({ modal: false, data: null});
        }
    };

    const getDeleteRecordFn = () => {
        if (revertApuTypes?.modal || bulkRevert?.modal) return onRevert;
        if (deleteApuTypes?.modal || bulkDelete?.modal) return onDelete;
        if (unLinkApuTypes?.modal || bulkUnlink?.modal) return  linkUnlink || null;
        return null;
    };
    const getManufacturers = () => {
        globalGetService(`config-data/manufacturers/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    let manufacturersFilter = [];
                    const data = response?.data?.data;
                    data && data.map((item) => {
                        manufacturersFilter.push({ id: item?.id, name: item?.name })
                    });
                    setManufacturersFilter(manufacturersFilter);
                }
            })
    }
    const getAircraftTypes = () => {
        globalGetService(`config-data/aircraft-type/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    let aircraftTypeInfo = [];
                    const data = response?.data?.data;
                    data && data.map((item) => {
                        aircraftTypeInfo.push({ id: item?.id, name: item?.name })
                    });
                    setFilterAircraftTypes(aircraftTypeInfo);
                }
            })
    }

    let filterOption = apuTypeFilters
    filterOption={
        ...filterOption,
         manufacturer:{
            ...filterOption.manufacturer,
            options:manufacturersFilter
        },
         aircraft_type:{
            ...filterOption.aircraft_type,
            options:filterAircraftTypes
        },
    }

    return (
        <section className="asset-tech-specs" style={{ margin: isApuTypes ? '0px' : '25px 0 0 75px' }}>
            {checkPermission('config_data', 'apu_types', 'R') ? 
            <Paper elevation={isApuTypes ? 0 : 1} className="tech-specs-card" style={{ height: isApuTypes ? `${window.innerHeight - 490}px` : `${window.innerHeight - 89}px` }}>
                {!isApuTypes ? <ConfigData /> : null}
                <div className="tech-specs-content" style={{ margin: isApuTypes ? "8px 0px 0px 0px" : '', paddingTop: '0px' }}>
                {skeletonLoader ? <STableLoader count={6} size={9} /> :
                    <div style={{ padding: isApuTypes ? '0px' : '10px' }}>
                        <Paper elevation={0} className="console-paper" style={{ padding: '4px 8px', marginBottom: '2px' }}>
                            <Grid container spacing={1} alignItems="center">
                                    <Grid item md={6}>
                                           {!isApuTypes ? <FilterComponent
                                                filter={filter}
                                                filterMenu={filterOption}
                                                getResponseBack={(applyFilter) => { getApuTypes({ ...applyFilter, page: 1, per_page: apuTypesInfo?.pagination?.per_page || 10 }, 'pageLoader') }}
                                            /> : null}
                                    </Grid>
                                    <Grid item md={6}>
                                        {!isApuTypes ? <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                            {revertCount > 0 && (
                                                <li className='list-inline-item'>
                                                    <Button onClick={() => { setBulkRevert({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Apu Types', item_type: 'Bulk Revert', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Revert Modal from Apu Types` }) }} color="primary" size='small' variant="outlined">
                                                        Revert ({revertCount})
                                                    </Button>
                                                </li>
                                            )}
                                            {deleteCount > 0 && (
                                                <li className='list-inline-item'>
                                                    <Button onClick={() => { setBulkDelete({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Apu Types', item_type: 'Bulk Delete', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Delete Modal from Apu Types` }) }} color="secondary" size='small' variant="contained">
                                                        Delete ({deleteCount})
                                                    </Button>
                                                </li>
                                            )}
                                            {checkPermission('config_data', 'apu_types', 'C') &&
                                                <li className='list-inline-item'>
                                                    <Button onClick={() => setAddEditApuTypes({ modal: true, data: ApuTypesObj, type: 'add' })} color="primary" size='small' variant="contained"><AddIcon style={{ fontSize: '1.15rem' }} />ADD</Button>
                                                </li>}
                                        </ul> : !deleted ? 
                                            <ul style={{textAlign:"right"}}>
                                                    {deleteCount > 0 && checkPermission('config_data', 'apu_types', 'D') &&(
                                                        <li className='list-inline-item'>
                                                            <Button onClick={() => { setBulkUnLink({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Apu Types', item_type: 'Bulk Unlink', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Unlink Apu Types to Aircraft Type` }) }} color="secondary" size='small' variant="contained">
                                                                Unlink ({deleteCount})
                                                            </Button>
                                                        </li>)}
                                                        {checkPermission('config_data', 'apu_types', 'U')  &&  <li className='list-inline-item'>
                                                    <Button onClick={() => setLinkingApu({ modal: true, data:apuTypesInfo})} color="primary" size='small' variant="contained">Link Apu Type</Button>
                                                </li> }
                                               
                                            </ul> : null}
                                    </Grid>
                            </Grid>
                        </Paper>
                        <Paper square>
                          <div style={{ height: isApuTypes ? `${window.innerHeight - (apuTypesInfo?.list?.length ? 535 : 480)}px` : `${window.innerHeight - (apuTypesInfo?.list?.length ? 200 : 150)}px`, overflow: 'auto' }}>
                             <Table className='mui-table-format' stickyHeader>
                                 <ApuTypesHeader isSelectAllChecked={isSelectAllChecked} deleted={deleted} isApuTypes={isApuTypes} handleSelectAll={(e) => handleSelectAll(e, currentPage)} createSortHandler={createSortHandler} sortInfo={sortInfo} />
                                    <TableBody>
                                        {apuTypesInfo?.list?.length > 0 && apuTypesInfo?.list?.map((item, index) =>
                                            <ApuTypesList
                                                deleted = {deleted}
                                                isApuTypes={isApuTypes}
                                                item={item}
                                                index={index}
                                                onDelete={setDeleteApuTypes}
                                                onRevert={setRevertApuTypes}
                                                unLink={setUnLinkApuTypes}
                                                onEditFn={() => setAddEditApuTypes({ modal: true, data: item, type: 'edit' })}
                                                onViewFn={() => setAddEditApuTypes({ modal: true, data: item, type: 'view' })}
                                                toggleBulkOps={(item, checked) => toggleBulkOps(item, checked, currentPage)}
                                                bulkIds={pageSelections[currentPage] || []}
                                            />
                                        )}
                                    </TableBody>
                              </Table>
                              {!apuTypesInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                            </div>
                        </Paper>
                        <Paper square>
                            <Pagination
                                pagination={apuTypesInfo?.pagination}
                                onChangePage={(event, newPage) => { getApuTypes({ ...filter, page: newPage + 1, per_page: apuTypesInfo.pagination?.per_page, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader'); setCurrentPage(newPage + 1) }}
                                onChangeRowsPerPage={(event) => getApuTypes({ ...filter, page: 1, per_page: event.target.value, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader')}
                            />
                        </Paper>
                    </div>}
                </div>
                {addEditApuTypes?.modal ?
                    <AddEditApuTypes
                        addEditApuTypes={addEditApuTypes}
                        apuTypesInfo={apuTypesInfo}
                        toggleModalFn={() => setAddEditApuTypes({ modal: false, apuTypesData: [] })}
                        getResponseBack={() => getApuTypes({...filter, page: apuTypesInfo?.pagination?.page, per_page: apuTypesInfo?.pagination?.per_page}, 'pageLoader')}
                        modeType={addEditApuTypes?.type}
                    /> : null
                }
                <DeletePopUp
                    confirmColor={getConfirmColor()}
                    confirmText={getConfirmText()}
                    modal={getModal()}
                    title={getTitle()}
                    content={getContent()}
                    toggleModalFn={toggleModalFn}
                    deleteRecordFn={getDeleteRecordFn()}
                    circularloader={circularLoader}
                />
            </Paper> :<NoAccess />}
            {isLoading ? <PageLoader /> : null}
            {linkingApu.modal &&
                <LinkingPopup 
                  title="Apu Type"
                  circularloader={circularLoader}
                  linkUnlink = {(type,ids)=>linkUnlink(type,ids)}
                  placeholder='Search By Apu Type ...'
                  description='No APU Types is available to link'
                  url={`config-data/aircraft-type/?linked_aircraft_types_name=APU_type&id=${params?.id}&action=unlink`}
                  data={apuTypesInfo}
                  toggleModalFn={() => setLinkingApu({modal:false, data:null})}
                />
                } 
        </section >
    )
}

export default withRouter(ApuTypes);